export default "__VITE_ASSET__4f8dfea9__"